import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image:width",
  content: 200
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image:height",
  content: 112.5
}, null, -1)
const _hoisted_4 = ["content"]
const _hoisted_5 = ["content"]
const _hoisted_6 = {
  id: "body",
  class: "template_offerlist"
}
const _hoisted_7 = { class: "page-header" }
const _hoisted_8 = { class: "width-wrap" }
const _hoisted_9 = {
  key: 0,
  class: "page-content"
}
const _hoisted_10 = { class: "estate-agency" }
const _hoisted_11 = { class: "width-wrap" }
const _hoisted_12 = { class: "estate-agency__content" }
const _hoisted_13 = { class: "estate-agency__company-info" }
const _hoisted_14 = { class: "estate-agency__logo" }
const _hoisted_15 = { class: "estate-agency__title" }
const _hoisted_16 = { class: "estate-agency__subtitle" }
const _hoisted_17 = { class: "estate-agency__contact-panel" }
const _hoisted_18 = { class: "estate-agency__address" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "estate-agency__contact" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 0,
  class: "estate-agency__agents"
}
const _hoisted_28 = { class: "width-wrap" }
const _hoisted_29 = { class: "listing listing--grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_ReadMore = _resolveComponent("ReadMore")!
  const _component_MapPositionReadonly = _resolveComponent("MapPositionReadonly")!
  const _component_EstateAgentPublicListItem = _resolveComponent("EstateAgentPublicListItem")!
  const _component_AdOfferList = _resolveComponent("AdOfferList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_ctx.$t('EstateAgencyPublicProfile.title')) + " " + _toDisplayString(_ctx.estateAgency.title), 1),
        (_ctx.image)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("meta", {
                property: "og:image",
                content: _ctx.image
              }, null, 8, _hoisted_1),
              _hoisted_2,
              _hoisted_3
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("meta", {
          name: "description",
          content: _ctx.estateAgency.metaDescription
        }, null, 8, _hoisted_4),
        _createElementVNode("meta", {
          property: "og:description",
          content: _ctx.estateAgency.metaDescription
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgencyPublicProfile.title')) + " " + _toDisplayString(_ctx.estateAgency.title), 1)
        ])
      ]),
      (_ctx.estateAgency && _ctx.estateAgency.estateAgencyId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ResizableImage, {
                        classes: "estate-agency-logo",
                        url: _ctx.estateAgency.logoRelativeUrl,
                        placeholder: "img/no-logo-agency.png",
                        width: 200,
                        height: 112.5,
                        alt: "agency"
                      }, null, 8, ["url"])
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.estateAgency.title), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('EstateAgencyPublicProfile.subtitle')) + " " + _toDisplayString(_ctx.estateAgency.yearCreated), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createTextVNode(_toDisplayString(_ctx.estateAgency.street), 1),
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.estateAgency.zip) + " " + _toDisplayString(_ctx.estateAgency.city), 1),
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString(_ctx.estateAgency.country), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateAgency.phoneNumbers, (phoneNumber, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createElementVNode("a", {
                              href: `tel:${phoneNumber}`
                            }, _toDisplayString(phoneNumber), 9, _hoisted_22),
                            _hoisted_23
                          ], 64))
                        }), 128)),
                        (_ctx.estateAgency.email)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                href: `mailto:${_ctx.estateAgency.email}`
                              }, _toDisplayString(_ctx.estateAgency.email), 9, _hoisted_24),
                              _hoisted_25
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.estateAgency.website)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: _ctx.estateAgency.website,
                              target: "_blank"
                            }, _toDisplayString(_ctx.webDomain), 9, _hoisted_26))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode(_component_ReadMore, {
                      class: "estate-agency__description",
                      text: _ctx.estateAgency.description,
                      textEn: _ctx.estateAgency.descriptionEn,
                      isTranslateEnabled: true,
                      max: 200,
                      moreText: _ctx.$t('EstateAgencyPublicProfile.show-more'),
                      lessText: _ctx.$t('EstateAgencyPublicProfile.show-less'),
                      onTranslate: _ctx.translate
                    }, null, 8, ["text", "textEn", "moreText", "lessText", "onTranslate"])
                  ]),
                  _createVNode(_component_MapPositionReadonly, {
                    class: "estate-agency__map",
                    ref: "map",
                    position: _ctx.position,
                    labelsEnabled: false
                  }, null, 8, ["position"])
                ])
              ]),
              (_ctx.estateAgents && _ctx.estateAgents.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyPublicProfile.agents')), 1),
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateAgents, (estateAgent) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "listing__item",
                            key: estateAgent.frontUserId
                          }, [
                            _createVNode(_component_EstateAgentPublicListItem, { estateAgent: estateAgent }, null, 8, ["estateAgent"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.estateAgency && _ctx.estateAgency.estateAgencyId)
              ? (_openBlock(), _createBlock(_component_AdOfferList, {
                  key: 0,
                  mode: _ctx.mode,
                  estateAgencyId: _ctx.estateAgency.estateAgencyId
                }, null, 8, ["mode", "estateAgencyId"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}